<template>
  <div>
    <form novalidate @submit.prevent="submit">
      <div class="row text-center">
        <div
          class="caixa-login col-xs-offset-2 col-sm-offset-4 col-md-offset-4 col-lg-offset-4 col-xs-8 col-sm-4 col-md-4 col-lg-4"
        >
          <h1 id="logo" class="logo"> cardea </h1>
          <br /><br />
          <div :class="{ 'has-error': v$.novaSenha.$error }" class="form-group">
            <label class="sr-only" for="novaSenha"> Nova senha </label>
            <div class="input-group">
              <div class="input-group-addon">
                <i class="fa fa-key" aria-hidden="true" />
              </div>
              <input
                v-model="novaSenha"
                data-test-id="input-nova-senha"
                type="password"
                class="form-control"
                placeholder="Nova senha"
                :readonly="enviado"
                @input="v$.novaSenha.$touch()"
              />
            </div>
          </div>
          <div
            :class="{ 'has-error': v$.novaSenhaCopia.$error }"
            class="form-group"
          >
            <label class="sr-only" for="novaSenha"> Confirme a senha </label>
            <div class="input-group">
              <div class="input-group-addon">
                <i class="fa fa-key" aria-hidden="true" />
              </div>
              <input
                v-model="novaSenhaCopia"
                data-test-id="input-confirmar-nova-senha"
                type="password"
                class="form-control"
                placeholder="Confirme a senha"
                :readonly="enviado"
                @input="v$.novaSenhaCopia.$touch()"
              />
            </div>
          </div>
          <div
            class="text-left"
            :class="enviado ? 'text-success' : 'text-primary'"
            style="margin: 2px 4px 18px 4px"
          >
            <span v-if="enviado">
              Senha atualizada com sucesso. Faça
              <router-link data-test-id="link-voltar-login" :to="'/login'">
                login!
              </router-link>
            </span>
            <span v-else>
              Infome a nova senha conforme as seguintes regras
            </span>
          </div>
          <ul class="row text-left" style="max-width: 300px; margin: 1rem auto">
            <li :class="linkValido ? 'text-success' : 'text-danger'">
              Link para recuperação válido
            </li>
            <li :class="senhaNovaConfere ? 'text-success' : 'text-danger'">
              As senhas conferem
            </li>
            <li :class="tamanhoValido ? 'text-success' : 'text-danger'">
              Com pelo menos 6 caracteres
            </li>
            <li :class="temNumeros ? 'text-success' : 'text-danger'">
              Com pelo menos um número (0-9)
            </li>
            <li :class="temLetras ? 'text-success' : 'text-danger'">
              Com pelo menos uma letra minúscula e maiúscula (A-z)
            </li>
            <li
              :class="temCaracteresEspeciais ? 'text-success' : 'text-danger'"
            >
              Com pelo menos uma um símbolo (@, $, #, _ ou &)
            </li>
          </ul>
          <br />
          <button
            data-test-id="button-nova-senha-confirmar"
            type="submit"
            class="btn btn-primary btn-block"
            :disabled="enviado"
          >
            Confirmar
          </button>
          <br />
          <br />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import Autenticacao from '@/servicos/Autenticacao'

const autenticacao = new Autenticacao()

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      email: '',
      novaSenha: '',
      novaSenhaCopia: '',
      enviado: false,
      linkValido: false,
    }
  },
  computed: {
    senhaNovaConfere() {
      return this.novaSenha && this.novaSenha === this.novaSenhaCopia
    },
    tamanhoValido() {
      return this.novaSenha.length >= 6
    },
    temNumeros() {
      return /\d/g.test(this.novaSenha)
    },
    temLetras() {
      return /([A-Z])/g.test(this.novaSenha) && /([a-z])/g.test(this.novaSenha)
    },
    temCaracteresEspeciais() {
      return /\W|_/g.test(this.novaSenha)
    },
  },
  mounted() {
    const { hash } = this.$route.params

    if (!hash) {
      return
    }

    autenticacao
      .verificarTokenParaNovaSenha(hash)
      .then((result) => {
        this.linkValido = true
        this.email = result.data.email
      })
      .catch((err) => {
        this.linkValido = false
        console.error(err)
      })
  },
  methods: {
    submit() {
      if (this.v$.$invalid) {
        this.v$.$touch()
        this.$alert({ content: 'Informe os campos corretamente.' })
      } else {
        const { hash } = this.$route.params
        autenticacao
          .enviarNovaSenha({
            _id: hash,
            email: this.email,
            nova_senha: this.novaSenha,
          })
          .then((result) => {
            this.enviado = true
          })
      }
    },
  },
  validations: {
    novaSenha: { required },
    novaSenhaCopia: { required },
  },
}
</script>

<style scoped>
.caixa-login {
  padding: 50px 50px 10px 50px !important;
  margin-top: 40px;
  background-color: #f7f9f9;
  box-shadow: 0 6px 32px rgba(0, 0, 0, 0.175);
}

.logo {
  position: relative;
  display: inline;
  margin-left: -36px;
  font-family: 'Crushed', Arial, Helvetica, sans-serif !important;
  font-size: 8em;
  font-weight: 400px;
  color: rgba(18, 128, 128, 0.5);
  letter-spacing: -7px;
}

.logo::after {
  position: absolute;
  top: 4px;
  left: 7px;
  color: rgba(128, 128, 18, 0.5);
  content: 'cardea';
}
</style>
